__turbopack_context__.v({
  "section": "SectionStyles-module-scss-module__MMPk4W__section",
});
